import * as React from 'react';
import styled from 'styled-components';
import { RowStyle } from 'ag-grid-community';
import { GridWrapper } from '@nkr/components/ag-grid/default-style';

export const styles: { [key: string]: React.CSSProperties } = {
    titleRow: {
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    title: {
        fontSize: 28,
        fontWeight: 500
    },
    filterWell: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: 5
    },
    filterItem: {
        marginRight: 20,
        marginBottom: 5
    },
    filterLabel: {
        marginRight: 5
    },
    select: {
        width: 170
    },
    searchInput: {
        width: 250
    },
    checkboxItem: {
        marginRight: 20,
        marginBottom: 5,
        alignSelf: 'flex-end'
    },
    checkboxLabel: {
        display: 'flex',
        alignItems: 'center',
        height: 34,
        margin: 0,
        fontWeight: 'normal',
        cursor: 'pointer'
    },
    checkboxInput: {
        margin: '0 6px 0 0'
    },
    buttonRow: {
        marginTop: 15
    },
    errorAlert: {
        marginBottom: 5
    },
    gridHidden: {
        display: 'none'
    }
};

export const HardToMatchGridWrapper = styled(GridWrapper)`
    .ag-header {
        background-color: #A02B93;
    }

    .ag-header-cell {
        color: white;
    }

    .ag-header-cell.recipient-header {
        background-color: #156082;
    }

    .ag-header-cell.donor-header {
        background-color: #196B24;
    }

    .ag-header-cell.match-header {
        background-color: #0F9ED5;
    }

    .ag-header-cell.review-header {
        background-color: #A02B93;
    }
`;

export const hiddenRowStyle: RowStyle = {
    color: '#999',
    fontStyle: 'italic'
};
